"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileTreeItemWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokens = require("@smartsheet/design-tokens");
var _react = _interopRequireDefault(require("react"));
const FileTreeItemWrapper = _ref => {
  let {
    spacing,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(StyledGroupWrapper, (0, _extends2.default)({
    spacing: spacing
  }, otherProps));
};
exports.FileTreeItemWrapper = FileTreeItemWrapper;
const StyledGroupWrapper = _styled.default.div(_ref2 => {
  let {
    spacing
  } = _ref2;
  return `
    display: flex;
    flex-direction: column;
    gap: ${_designTokens.space.space10};
    width: 100%;
    padding-left: ${spacing};
    box-sizing: border-box;
`;
});
//# sourceMappingURL=FileTreeItemWrapper.js.map